import { network } from 'services/network';

export const getLogicCheckerSummary = (params) => {
    return network.post('api/bo/getLogicCheckerSummary', params).then((response) => {
        return response.data;
    });
};
